/**
 * Specify who disconnected this call
 */
export enum DisconnectedBy {
  callerValue = 'caller',

  calleeValue = 'callee',

  server = 'server',
}
